import { ITranslateIfLanguageKey } from "./types";
import { TranslationService } from "../../../services/translate";
import { LANGUAGE_KEY_REG_EXP } from "@constants/regexp";
import { TxKeyPath } from "@services/translate/__types__";

export const translateIfLanguageKey: ITranslateIfLanguageKey = (
  message: string
): string => {
  if (LANGUAGE_KEY_REG_EXP.test(message))
    return TranslationService.t(message as TxKeyPath);

  return message;
};
